import axios from 'axios';
import {AXIOS_DEFAULT_CONFIG, CONSOLE_REQUEST_ENABLE, CONSOLE_RESPONSE_ENABLE} from '@/config';
import {get} from 'lodash';
import router from '@/plugins/router';
import store from '@/plugins/store';

function requestSuccessFunc(requestObj) {
  CONSOLE_REQUEST_ENABLE && console.info('requestInterceptorFunc', `url: ${requestObj.url}`, requestObj);
  // 处理权限，请求发送监控

  return requestObj;
}

function requestFailFunc(requestError) {
  // 发送请求失败处理

  return Promise.reject(requestError);
}

// 响应成功
function responseSuccessFunc(responseObj) {
  if (responseObj.headers['content-type'].indexOf('application/vnd.ms-excel') !== -1) {
    return responseObj.data;
  }
  CONSOLE_RESPONSE_ENABLE && console.log('requestInterceptorFunc', 'data: ', responseObj.data);
  return responseObj.data.data;
}

// 本文件是实际使用的axios
function responseFailFunc(responseError) {
  console.log('------------------------responseFailFunc ');
  console.log(responseError.response);
  if (responseError.response) {
    switch (responseError.response.status) {
      // case 403:
      //   location.reload()
      //   break
      case 201:
      case 202:
        break;
      case 400:
        let errorMsg = (responseError.response && responseError.response.data && responseError.response.data.msg) ? responseError.response.data.msg : '业务异常';
        responseError.message = get(responseError, 'response.data.message', errorMsg);
        break;
      case 401:
        // Unauthorized 鉴权失败，跳转到登录页面
        // responseError.message = get(responseError, 'response.data.message', '鉴权失败')
        toLogin();
        break;
      case 403:
        console.log('------------------403 error::');
        toLogin();
        return;
      case 500:
        errorMsg = (responseError.response && responseError.response.data && responseError.response.data.msg) ? responseError.response.data.msg : '服务错误';
        responseError.message = get(responseError, 'response.data.message', errorMsg);
        break;
      default:
        responseError.message = get(responseError, 'response.data.message', '出错啦');
    }
  }
  // 自定义错误码，弹窗显示错误内容
  let code = responseError.response.data.code;
  if (code && code > 10000000 && code < 99999999) {
    global.vbus.$emit('global.$Message.show', responseError.message);
  }
  // responseError.config && !responseError.config.noShowDefaultError && global.vbus.$emit('global.$Message.show', responseError.message)

  return Promise.reject(responseError);
}

/**
 * 跳转登录页面
 */
function toLogin() {
  // alert('没有访问权限')
  store.dispatch('handleLogOut');
  let {name, params} = {};
  name = 'adminLogin';
  router.push({name, params});// Forbidden没有权限，跳转到登录页面
  // responseError.message = get(responseError, 'response.data.message', '您没有访问权限')
}

let axiosInstance = axios.create(AXIOS_DEFAULT_CONFIG);

// 注入请求拦截
axiosInstance
  .interceptors.request.use(requestSuccessFunc, requestFailFunc);
// 注入失败拦截
axiosInstance
  .interceptors.response.use(responseSuccessFunc, responseFailFunc);

export default axiosInstance;
